import React, { useEffect,useState } from 'react';
import Accordian from "../../components/Common/Accordian";
import Searching from '../../components/Searching';
import NoDataFound from '../../components/NoDataFound';

import { postData } from '../../services/api';
import { useTranslation } from "react-i18next";


const FaqV2 = () => {
  const { i18n,t } = useTranslation();
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [faqs, setfaqs] = useState([]);

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  }; 

  useEffect(() => {
    const loadList = async () => {
      setLoading(true);
      const result = await postData("/faq/list", {
        sortQuery: {"created_at":-1},
      });
      if (result.data) {
        setfaqs(
          result.data.map((item,index)=>{
            return {
              title : item?.question?.[i18n?.language],
              content : item?.answer?.[i18n?.language]
            }
          })
        );
        setLoading(false);
      }
    };
    loadList();
  }, [i18n]);

  const FaqData = {
    title:t('frequently_asked_questions'),
    Faq : faqs
  }
  return (
      <>          
          <section className="relative w-full py-10 lg:py-14 xl:py-16 2xl:py-20 bg-white ">
              <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl  mx-auto">
                  <div className="max-w-3xl w-full mx-auto text-center mb-5 xs:mb-10 xl:mb-20 lg:space-y-10 xl:space-y-16">
                        <h2 className="capitalize text-slate-950 text-2xl xs:text-3xl !leading-tight lg:text-4xl xl:text-5xl font-extrabold font-PlusJakartaSans" dangerouslySetInnerHTML={{__html:FaqData.title}}></h2>
                  </div>        
                  {(FaqData.Faq && FaqData.Faq.length>0)?
                  FaqData.Faq.map((item, index) => (
                    <Accordian
                      key={index}
                      id={index}
                      title={item.title}
                      isOpen={openAccordionId === index}
                      toggleAccordion={toggleAccordion}
                    >
                      <div className="text-sm md:text-base font-Inter text-slate-700">{item.content}</div>
                    </Accordian>
                  )):loading ? <Searching label={'Searching'} /> : <NoDataFound label={'No Data Found'}/> }               
              </div>
          </section>
      </>
  );
};

export default FaqV2;